import React from "react";
import { Home, Briefcase, Bus } from "lucide-react";
import { priorities } from "../mock";

const ICONS = { Home, Briefcase, Bus };

const Priorities = () => {
  return (
    <section
      id="priority"
      className="bg-campaign-cream py-16 sm:py-24 px-4 sm:px-6 border-t-4 border-campaign-ink"
    >
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display text-3xl sm:text-5xl text-campaign-ink leading-none mb-10 uppercase">
          {priorities.heading}
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {priorities.items.map((item) => {
            const Icon = ICONS[item.icon] || Home;
            return (
              <div
                key={item.no}
                className="bg-campaign-yellow border-4 border-campaign-ink p-6 shadow-brutal hover-lift"
              >
                <div className="flex items-center justify-between mb-4">
                  <span className="w-12 h-12 bg-campaign-blue border-2 border-campaign-ink flex items-center justify-center">
                    <Icon size={24} className="text-campaign-yellow" />
                  </span>
                  <span className="font-display text-4xl text-campaign-ink/15">{item.no}</span>
                </div>
                <h3 className="font-display text-xl text-campaign-ink mb-2 uppercase">{item.title}</h3>
                <p className="text-campaign-ink/80">{item.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Priorities;
